module.exports = __webpack_public_path__ + "img/1_4.3829b54c.png";